import * as actionTypes from './actionsTypes';

export const setupdatecart = (payload) => {
    return {
        type: actionTypes.SETUPDATECART,
        value: payload
    }
}